import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteGroup: (
  fetchContext: FetchContext,
  groupId: number,
  accessToken?: string) => Promise<void> = (fetchContext, groupId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/groups/${groupId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete group', false));
